<template>
  <Icon
    v-bind="$attrs"
    :icon="resolvedIcon"
    :width="width"
    :height="height"
    :color="color"
    :rotate="rotate"
    :flip="flip"
    :inline="inline"
    :h-flip="hFlip"
    :v-flip="vFlip"
    :align="align"
    @click="$emit('click', $event)"
  />
</template>

<script>
import { Icon } from '@iconify/vue2'

export default {
  name: 'AppIcon',
  components: {
    Icon
  },
  inheritAttrs: false,
  props: {
    icon: {
      type: [String, Object],
      default: null
    },
    type: {
      type: String,
      default: null
    },
    width: {
      type: [String, Number],
      default: null
    },
    height: {
      type: [String, Number],
      default: null
    },
    color: {
      type: String,
      default: null
    },
    rotate: {
      type: [String, Number],
      default: null
    },
    flip: {
      type: String,
      default: null
    },
    inline: {
      type: Boolean,
      default: false
    },
    hFlip: {
      type: Boolean,
      default: false
    },
    vFlip: {
      type: Boolean,
      default: false
    },
    align: {
      type: String,
      default: null
    }
  },
  computed: {
    resolvedIcon() {
      return this.icon || this.type
    }
  }
}
</script>
